// removed by extract-text-webpack-plugin
module.exports = {"about":"src-pages-about----styles-module---about---3PJ7p","intro":"src-pages-about----styles-module---intro---2WL5H","skills":"src-pages-about----styles-module---skills---2OOGI","interests":"src-pages-about----styles-module---interests---17omM","interest":"src-pages-about----styles-module---interest---3-bT2"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/styles.module.css
// module id = ./src/pages/about/styles.module.css
// module chunks = 116195567845805